module.exports = __webpack_public_path__ + "img/p05702.c9658545.png";